module.exports = __webpack_public_path__ + "static/media/Sunroof.f3d03285.svg";